export default __webpack_public_path__ + "static/media/generate.8cf107de.svg";